import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonBackButton, IonTitle, IonButton, IonIcon, IonContent, IonList, IonItem } from '@ionic/angular/standalone';
import { Store } from "@ngrx/store";
import { ApiModules, ApiOperations, DisplayService, RolePipe } from '@qid/core';
import { Environment, ENVIRONMENT } from '@qid/env';
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent, SuperSkeletonComponent } from "@qid/super";
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { activeAccountChanges } from '../../modules/authentication';
import { Organisation } from '../../modules/organisation';
import {
  AddOrgUserPage,
  OrganisationUser,
  OrganisationUserDataRepository,
  OrganisationUserSelectors
} from '../../modules/organisation-user';
import { PermissionDirective } from '../../modules/organisation-user/directives/permission.directive';
import {
  OrganisationUserPermissionsPage
} from "../organisation-user-permissions/organisation-user-permissions-page.component";
import { AppName } from '../../enum/app-name.enum';

@Component({
  selector: 'app-organisation-users',
  templateUrl: './organisation-users.page.html',
  styleUrls: ['./organisation-users.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    PermissionDirective,
    AvatarRoundComponent,
    RolePipe,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonItem
  ],
})
export class OrganisationUsersPage implements OnInit {

  @ViewChild('usersSkeleton') usersSkeleton: SuperSkeletonComponent;

  public organisation: Organisation;

  public organisationUsers$ = this.organisationUserDataRepository.allOrganisationUsers$;

  public pageClosed$ = new Subject<void>();

  public readonly showZohoPaymentAccount = this.environment.appName === AppName.Master;

  constructor(
    private organisationUserDataRepository: OrganisationUserDataRepository,
    private modalController: ModalController,
    private store: Store,
    private displayService: DisplayService,
    @Inject(ENVIRONMENT) private environment: Environment,
  ) {
  }

  ngOnInit() {

  }

  ionViewDidEnter() {
    this.pageClosed$ = new Subject<void>();
    activeAccountChanges(this.store)
      .pipe(takeUntil(this.pageClosed$))
      .subscribe(() => {
        this.organisationUserDataRepository.init()
      })
  }

  ionViewDidLeave() {
    this.pageClosed$.next();
    this.pageClosed$.complete()
  }

  async addUser() {
    const modal = await this.modalController.create({
      component: AddOrgUserPage,
    });
    modal.present();
  }

  public getDeleteOrgUserAlertMessage = () => {
    return `Remove User from ${this.organisation.name}?`;
  };

  public async openViewUser(orgUser: OrganisationUser) {
    const activeOrgUser = await firstValueFrom(this.store.select(OrganisationUserSelectors.selectActiveOrganisationUser))
    if (!PermissionDirective.hasPermission(activeOrgUser, ApiModules.OrganisationUser, ApiOperations.update)) {
      return this.displayService.toast({
        message: "You do not have permission to view this user",
        color: "danger"
      })
    }
    const modal = await this.modalController.create({
      component: OrganisationUserPermissionsPage,
      componentProps: {
        organisationUser: orgUser,
        showZohoPaymentAccount: this.showZohoPaymentAccount,
      }
    })
    await modal.present()
    await modal.onDidDismiss()
    if (this.showZohoPaymentAccount) {
      this.organisationUserDataRepository.init()
    }
  }

  protected readonly ApiOperations = ApiOperations;
  protected readonly ApiModules = ApiModules;
}
